import { render, staticRenderFns } from "./Variable.vue?vue&type=template&id=3b1f5330&scoped=true&"
import script from "./Variable.vue?vue&type=script&lang=js&"
export * from "./Variable.vue?vue&type=script&lang=js&"
import style0 from "./Variable.vue?vue&type=style&index=0&id=3b1f5330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f5330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
